// extracted by mini-css-extract-plugin
module.exports = {"dialog":"ChangeUserPasswordModal_dialog__3oGQs","body":"ChangeUserPasswordModal_body__Ug8dG"};